module.exports = __webpack_public_path__ + "static/media/paypal.3bc3fdf1.svg";